// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2kLCq","inputDescription":"styles_inputDescription__1fzcz"};